<script setup lang="ts">
import { fetchCryptoDepositInit } from "@/app/api"
import BaseTextField from "@/app/components/ui/BaseTextField.vue"
import { t } from "@/app/composables/useI18n"
import { onMounted, ref, watch } from "vue"

const props = defineProps({
  currencyId: {
    type: Number,
    required: true,
  },
  providerId: {
    type: Number,
    required: true,
  },
})

interface ICryptoDeposit {
  crypto_address: string
  min_amount: number
  fee: number
  qr_code_data_uri: string
}

const depositData = ref<ICryptoDeposit>({
  crypto_address: null,
  min_amount: 0,
  fee: 0,
  qr_code_data_uri: "",
})

async function cryptoDepositInit() {
  const payload = {
    provider_id: props.providerId,
    currency_id: props.currencyId,
  }
  const { data } = await fetchCryptoDepositInit(payload)
  const result = data.data as ICryptoDeposit

  depositData.value = result
}

watch(
  () => props.providerId,
  () => {
    cryptoDepositInit()
  },
)

watch(
  () => props.currencyId,
  () => {
    cryptoDepositInit()
  },
)

onMounted(() => {
  cryptoDepositInit()
})
</script>

<template>
  <div v-if="depositData?.crypto_address !== null">
    <BaseTextField
      :model-value="depositData.crypto_address"
      :label="t('finance.deposit_address')"
      type="text"
      :readonly="true"
      icon-name="copy"
      class="crypto-address"
    />

    <div class="qr-code">
      <img :src="depositData.qr_code_data_uri">
    </div>
    <p class="deposit-intro">
      {{ t("finance.deposit_intro") }}
    </p>
  </div>
  <div>
    <span class="label">{{ t("finance.min_deposit") }}:</span>
    <span class="value">{{ depositData.min_amount }}</span>
  </div>
  <div>
    <span class="label">{{ t("finance.fee") }}:</span>
    <span class="value">{{ +depositData.fee * 100 }}%</span>
  </div>
</template>

<style lang="scss" scoped>
.label {
  margin-bottom: 7px;
}

.qr-code {
  display: flex;
  justify-content: center;
  margin-bottom: 10px;
}

.crypto-address {
  margin-bottom: 10px;
}

.deposit-intro {
  margin-top: 0px;
  margin-bottom: 14px;
}

span.label {
  font-size: 14px;
}

span.value {
  font-weight: normal !important;
  padding-left: 10px;
  font-size: 14px;
}
</style>
